<template>
	<v-layout>
		<v-flex xs12>
			<v-card>
				<v-carousel :hide-delimiters="images.length > 28" height="100vh">
					<v-carousel-item v-for="(image, i) in images" :key="i" class="extra-contain" lazy :src="image.src"></v-carousel-item>
				</v-carousel>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: 'StateMessages',
	components: {},
	props: {
		title: {
			type: String,
			required: true
		}
	},
	data: () => ({
		height: window.innerHeight
	}),
	computed: {
		images() {
			return this.$store.state.images
		}
	},
	mounted() {
		this.$store.dispatch('getVacation', this.$route.params.id)
	},
	methods: {}
}
</script>
<style lang="scss">
.v-carousel__item .v-image__image.v-image__image--cover {
	background-size: contain;
}
</style>
